import { FC } from 'react';

// Components
import TournamentIcon from './TournamentIcon';

// Utils
import { classNames } from '@sportal365/smp-widget-utils';

// Types
import { ITournament } from '../../../types';
import { ISubscriberInfo } from '../../../../../../packages/types';

interface Props {
  tournaments?: ITournament[];
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

const Tournaments: FC<Props> = ({ tournaments, handleClick }) => {
  const isEqualDistributed = tournaments && tournaments.length > 3;

  return (
    <div
      className={classNames({
        'tournaments-container flex gap-1 justify-between sm:justify-normal': true,
        'justify-between': isEqualDistributed,
      })}
    >
      {tournaments?.map((tournament) => <TournamentIcon key={tournament.id} {...tournament} handleClick={handleClick} />).slice(0, 6)}
    </div>
  );
};

export default Tournaments;
